// extracted by mini-css-extract-plugin
export var button = "_cy-0";
export var donut = "_cy-1";
export var donutFill = "_cy-3";
export var donutTrack = "_cy-2";